import { Label } from '@/types/workflow-types';
import { apiRequest } from '@/utils/api-request';

interface GetOrgLabelsResponse {
  data?: {
    labels: Label[];
    count: number;
  };
  detail?: string;
}

export async function getOrgLabels(
  orgId: string,
): Promise<GetOrgLabelsResponse> {
  const response = await apiRequest<GetOrgLabelsResponse>({
    url: `/api/v1/orgs/${orgId}/labels`,
    target: 'workflow',
    method: 'GET',
  });

  return response as GetOrgLabelsResponse;
}
